import * as React from "react";

import { EmptyListPlaceholder } from "components/emptyListPlaceholder";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { StatisticByEmployeesTable } from "./index";
import { Loader } from "../../components/loader/Loader";
import { getEmployeesDetails } from "../../redux/actions/employeeActions";
import { useNavigate } from "react-router-dom";

export const StatisticsByEmployees = () => {
  const dispatch = useAppDispatch();
  const { employeeDetails, loadingStatus } = useAppSelector((state) => state.employeeDetails);
  const isLoading = loadingStatus === "NotLoaded" || loadingStatus === "Loading";

  const handleView = () => {
    if (employeeDetails.length !== 0) {
      return <StatisticByEmployeesTable employeeDetails={employeeDetails} />;
    }

    return <EmptyListPlaceholder />;
  };

  const handleLoader = () => {
    if (isLoading) {
      return <Loader />;
    }

    return null;
  };

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/statistics");
  };

  React.useEffect(() => {
    dispatch(getEmployeesDetails());
  }, [dispatch]);

  return (
    <main className="main">
      <div className="wrap">
        <div className="intro intro--stats">
          <button type="button" onClick={handleNavigate} className="link link--icon link--arrow-left">
            Back
          </button>
          <h1 className="intro__title">Statistics by <span className="intro__title-highlight">employees</span></h1>
        </div>
        <div className="manager">
          {handleLoader()}
          {handleView()}
        </div>
      </div>
    </main>
  );
};
